module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "check_wrapper",
    class: {
      disabled: _vm.disabled
    },
    style: (_vm.getStyle),
    on: {
      "click": _vm.click,
      "mouseover": function($event) {
        return _vm.hover(true)
      },
      "mouseleave": function($event) {
        return _vm.hover(false)
      }
    }
  }, [_c('div', {
    staticClass: "check_box",
    class: {
      checked: _vm.dataInput
    }
  }, [_c('AppSvgIcon', {
    staticClass: "apply",
    attrs: {
      "color-mode": "stroke",
      "template": _vm.$ui.IconSvgComponents.apply,
      "size": "auto"
    }
  })], 1), _c('div', {
    staticClass: "check_box_label"
  }, [_vm._v(_vm._s(this.label || '')), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bc0ca18","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppCheckBox/AppCheckBox.vue
// module id = 5317bb4a0fe6208f84d2
// module chunks = 29